import React from 'react';

export class OpenCloseMarker extends React.Component<{ open: boolean }> {
  render() {
    const baseStyle: React.CSSProperties = { display: 'inline-block', fontSize: '0.85em' };
    if (this.props.open) {
      return <span style={{ ...baseStyle, transform: 'rotate(90deg)' }}>▶</span>;
    }
    return <span style={{ ...baseStyle }}>▶</span>;
  }
}
